import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function RequestResetPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Email wajib diisi");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        "https://backend.smpn1kamal.sch.id/api/forgot-password",
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Link reset kata sandi berhasil dikirim ke email");
      setEmail("");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Gagal mengirim link reset kata sandi",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* HEADER */}
      <header className="bg-white shadow px-6 py-4">
        <h1 className="text-xl font-bold text-blue-700">SIPENSA</h1>
      </header>

      {/* CONTENT */}
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="bg-white p-6 rounded-xl shadow w-full max-w-sm">
          <h1 className="text-xl font-bold mb-2 text-center">
            Lupa Kata Sandi
          </h1>

          <p className="text-sm text-gray-600 mb-5 text-center">
            Masukkan email yang terdaftar untuk menerima link reset kata sandi
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Masukkan email"
              className="w-full border px-3 py-2 mb-4 rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            {/* 🔥 TOMBOL KIRI - KANAN */}
            <div className="flex gap-2">
              <Link
                to="/"
                className="w-1/2 text-center bg-gray-200 text-gray-700 py-2 rounded hover:bg-gray-300"
              >
                Kembali
              </Link>

              <button
                type="submit"
                disabled={loading}
                className="w-1/2 bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-60"
              >
                {loading ? "Mengirim..." : "Kirim Link Reset"}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}